module.exports = __webpack_public_path__ + "static/media/live-chat.e7d92e58.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifs/live-chat.gif
// module id = z6IM
// module chunks = 89